












































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Icon } from 'vant';

Vue.use(Icon);

@Component
export default class CommentItem extends Vue {
  @Prop() commentItem!: any;
  @Prop({ default: false }) isUserZone!: boolean;

  status: string[] = ['待审核', '审核通过', '审核未通过'];
  statusStyle: string[] = ['status-pending', 'status-passed', 'status-reject'];
}
